/**
 * @generated SignedSource<<ca1c7a6cef9da8e8bbcb87cb178dfbd0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type JiraFormattingArea = "CELL" | "ROW" | "%future added value";
export type JiraFormattingMultipleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "HAS_ANY_OF" | "%future added value";
export type JiraFormattingNoValueOperator = "IS_EMPTY" | "IS_NOT_EMPTY" | "%future added value";
export type JiraFormattingSingleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "DOES_NOT_EQUAL" | "EQUALS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUALS" | "IS" | "IS_AFTER" | "IS_BEFORE" | "IS_NOT" | "IS_ON_OR_AFTER" | "IS_ON_OR_BEFORE" | "LESS_THAN" | "LESS_THAN_OR_EQUALS" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type formatRuleConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly expression: {
        readonly __typename: "JiraFormattingMultipleValueOperand";
        readonly fieldId: string;
        readonly multipleValueOperator: JiraFormattingMultipleValueOperator;
        readonly values: ReadonlyArray<string>;
      } | {
        readonly __typename: "JiraFormattingNoValueOperand";
        readonly fieldId: string;
        readonly noValueOperator: JiraFormattingNoValueOperator;
      } | {
        readonly __typename: "JiraFormattingSingleValueOperand";
        readonly fieldId: string;
        readonly singleValueOperator: JiraFormattingSingleValueOperator;
        readonly value: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly formattingArea: JiraFormattingArea;
      readonly formattingColor: {
        readonly colorKey: string | null | undefined;
      };
      readonly id: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "formatRuleConnection";
};
export type formatRuleConnection$key = {
  readonly " $data"?: formatRuleConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"formatRuleConnection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "formatRuleConnection"
};

(node as any).hash = "5359e5106c613cccc6e8a2b7c3819ced";

export default node;
